(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const contactForm = document.getElementById('ContactForm')

    if (contactForm) {
      contactForm.addEventListener('submit', function (event) {
        const verificationInput = document.getElementById('ContactForm-Verification')
        const nameInput = document.getElementById('ContactForm-Name')

        if (verificationInput && nameInput) {
          const verificationValue = verificationInput.value.trim().toLowerCase()
          const acceptedValues = ['blue', 'bule', 'bleu', 'bloo', 'blu', 'bloue', 'bluu']

          const responseVerified = acceptedValues.includes(verificationValue)

          if (!responseVerified) {
            nameInput.value = '[SPAM] ' + nameInput.value
          }
        }
      })
    }
  })

  } catch(e) { console.error(e); }
})();
})();
